// Mapping des codes pays vers les vrais noms
const COUNTRY_CODE_TO_NAME = {
  'AT': 'Austria',
  'BA': 'Bosnia and Herzegovina',
  'BE': 'Belgium',
  'CH': 'Switzerland',
  'DE': 'Germany',
  'DK': 'Denmark',
  'EE': 'Estonia',
  'ES': 'Spain',
  'FI': 'Finland',
  'FR': 'France',
  'GB': 'United Kingdom',
  'GG': 'Guernsey',
  'HR': 'Croatia',
  'HU': 'Hungary',
  'IE': 'Northern Ireland',
  'IS': 'Iceland',
  'IT': 'Italy',
  'JE': 'Jersey',
  'JP': 'Japan',
  'KE': 'Kenya',
  'LU': 'Luxembourg',
  'NL': 'Netherlands',
  'NO': 'Norway',
  'PE': 'Peru',
  'PL': 'Poland',
  'UG': 'Uganda',
  'ZA': 'South Africa',
  'US': 'United States',
}

const CURRENCY_TO_FLUX = {
  'gbp': 'uk-vente',
  'eur': 'eu-vente',
  'usd': 'us-vente',
}

// Utilitaire pour convertir les mois en index (0-11)
const MONTH_TO_INDEX = {
  JAN: 0,
  FEB: 1,
  MAR: 2,
  APR: 3,
  MAY: 4,
  JUN: 5,
  JUL: 6,
  AUG: 7,
  SEP: 8,
  OCT: 9,
  NOV: 10,
  DEC: 11,
}

// Calculer les périodes de 12 mois glissants
function calculateRollingPeriods(startMonth) {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() // 0-11
  const startMonthIndex = MONTH_TO_INDEX[startMonth]

  const periods = []

  for (let i = 0; i < 5; i++) {
    // Calculer l'année de début pour cette période
    let startYear = currentYear - i - 1
    
    // Si le mois de début est après le mois actuel, la période courante n'est pas encore terminée
    if (startMonthIndex > currentMonth) {
      startYear -= 1
    }

    // Date de début: 1er jour du mois de début
    const startDate = new Date(startYear, startMonthIndex, 1)
    
    // Date de fin: dernier jour du mois précédent le mois de début de l'année suivante
    // Par exemple, si on commence en FEB, on finit le dernier jour de JAN de l'année suivante
    const endDate = new Date(startYear + 1, startMonthIndex, 0)
    
    const endMonthLabel = getPreviousMonthLabel(startMonth)
    
    periods.push({
      label: `${startMonth} ${startYear} - ${endMonthLabel} ${startYear + 1}`,
      yearKey: `period_${i + 1}`,
      startDate,
      endDate,
    })
    
    console.log(`📅 Period ${i + 1}: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`)
  }

  return periods
}

// Obtenir le mois précédent
function getPreviousMonthLabel(monthLabel) {
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
  const currentIndex = months.indexOf(monthLabel)
  const previousIndex = currentIndex === 0 ? 11 : currentIndex - 1
  return months[previousIndex]
}

// Vérifier si une date est dans une période donnée
function isDateInPeriod(date, period) {
  return date >= period.startDate && date <= period.endDate
}

// Transforme les données brutes PostgreSQL en collection pour GeneralView/DynamicDashboard
function buildGeneralViewCollection(rawData, periodFilters = {}) {
  console.log("🔄 Transforming raw data for General View...")

  const { periodType = "YEAR", month = "JAN" } = periodFilters
  console.log(`📅 Period configuration: ${periodType}, starting month: ${month}`)

  // Calculer les périodes selon le type sélectionné
  let periods = []
  let yearField = 'year'

  if (periodType === "12M ROLLING") {
    periods = calculateRollingPeriods(month)
    yearField = 'period' // Utiliser un champ dynamique pour les périodes
    console.log(`📊 Calculated ${periods.length} rolling periods:`, periods.map(p => p.label))
  } else {
    // Mode YEAR classique - on garde les 5 dernières années
    const allYears = [...new Set(rawData.map(row => {
      try {
        return new Date(row.order_invoice_date).getFullYear()
      } catch {
        return null
      }
    }).filter(Boolean))].sort((a, b) => b - a) // Tri décroissant

    periods = allYears.slice(0, 5).map(year => ({
      label: year.toString(),
      yearKey: year.toString(),
      year,
    }))
    console.log(`📊 Using ${periods.length} calendar years:`, periods.map(p => p.label))
  }

  const transformedData = []

  let processedCount = 0
  let skippedCount = 0
  
  // eslint-disable-next-line no-restricted-syntax
  for (const row of rawData) {
    // Parse invoice date
    let invoiceDate = null
    if (row.order_invoice_date) {
      try {
        invoiceDate = new Date(row.order_invoice_date)
        if (isNaN(invoiceDate.getTime())) {
          console.warn('Invalid date:', row.order_invoice_date)
          skippedCount++
          // eslint-disable-next-line no-continue
          continue
        }
      } catch (error) {
        console.warn('Date parsing error:', error, row.order_invoice_date)
        skippedCount++
        // eslint-disable-next-line no-continue
        continue
      }
    }

    if (!invoiceDate || !row.order_item_amount_cents || row.order_item_amount_cents <= 0) {
      skippedCount++
      // eslint-disable-next-line no-continue
      continue
    }

    // Déterminer dans quelle(s) période(s) cette ligne appartient
    let periodValue = null

    if (periodType === "12M ROLLING") {
      // Trouver la période correspondante
      const matchingPeriod = periods.find(period => isDateInPeriod(invoiceDate, period))
      if (matchingPeriod) {
        periodValue = matchingPeriod.yearKey
        processedCount++
      } else {
        skippedCount++
        // eslint-disable-next-line no-continue
        continue // Ignorer les lignes qui ne sont dans aucune période
      }
    } else {
      // Mode YEAR classique
      const year = invoiceDate.getFullYear()
      const matchingPeriod = periods.find(p => p.year === year)
      if (matchingPeriod) {
        periodValue = matchingPeriod.yearKey
        processedCount++
      } else {
        skippedCount++
        // eslint-disable-next-line no-continue
        continue // Ignorer les années non comprises dans les 5 dernières
      }
    }

    // Use real country from buyer or delivery entity (prefer buyer)
    const countryCode = (row.buyer_country_code || row.delivery_entity_country_code || '').toUpperCase()
    const countryName = COUNTRY_CODE_TO_NAME[countryCode] || countryCode || 'Unknown'

    // Buyer N1: use the value directly from buyer_p1 (already transformed in the view)
    const buyerN1 = row.buyer_p1 || "Unknown"

    const transformed = {
      // Fields for filters
      currency: row.order_currency,
      typeFlux: CURRENCY_TO_FLUX[row.order_currency] || 'unknown',
      buyerN1,
      buyerEntityN2: row.buyer_name || row.buyer_p2,

      // Fields for hierarchy
      country: countryName,
      buyerEntity: row.buyer_name,
      deliveryEntity: row.delivery_entity_name,
      productName: row.product_name || row.sku_code || 'Unknown Product',

      // Value fields
      total: parseFloat(row.order_item_amount_cents),
      [yearField]: periodValue, // Utiliser le champ dynamique (year ou period)

      // Additional fields
      quantity: row.order_item_quantity,
      buyer_p2: row.buyer_p2,
      buyer_p1: row.buyer_p1,
      sku_code: row.sku_code,
      order_invoice_date: row.order_invoice_date,
      order_invoice_date_annee_mois: row.order_invoice_date_annee_mois,
      country_code: countryCode,
    }

    transformedData.push(transformed)
  }

  console.log(`✅ Transformed ${transformedData.length} records for General View`)
  console.log(`📊 Processed: ${processedCount}, Skipped: ${skippedCount}`)
  
  return {
    data: transformedData,
    periods: periodType === "12M ROLLING" ? periods : null,
  }
}

export default buildGeneralViewCollection